import React from 'react';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import { AlertCircle, Info } from 'react-feather';

const iconsRegionMap = {
  alert: AlertCircle,
  info: Info,
};

const AlertIcon = ({ icon }) => {
  if (!icon) return null;
  const Icon = iconsRegionMap[icon] || iconsRegionMap[alert];
  return (
    <div className="mr-16">
      <Icon width="16" />
    </div>
  );
};

const Alert = ({ icon, type = 'info', children }) => {
  return (
    <div className={`alert-box alert-box--${type}`}>
      <AlertIcon icon={icon} />
      <Text variant={TEXT_VARIANTS.BODY_LIGHT} component="div">
        {children}
      </Text>
    </div>
  );
};

export default Alert;
